// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TIKTOK_UNABLE_TO_LOAD_TIKTOK_VIDEO = "Nepodarilo sa na\u010d\u00edta\u0165 TikTok video.";
export const TIKTOK_VIEW_ON_TIKTOK = "Zobrazi\u0165 na TikTok";
